<template>
  <div class="alert-block">
    <div
      class="alert-block__message-type"
      :class="type.toLowerCase()"
    >
      <svgicon
        class="alert-block__error-icon"
        :name="
          type.toLowerCase() == 'warning' ? 'Alerts/Warning' : 'Alerts/Info'
        "
      />
    </div>
    <div class="alert-block__content">
      <h3
        v-if="title"
        class="alert-block__title"
        v-text="title"
      />
      <p
        v-if="preamble"
        class="alert-block__text"
        v-text="preamble"
      />
      <link-wrapper :url="url" />
    </div>
  </div>
</template>

<script>
import "#/Alerts/Warning"
import "#/Alerts/Info"
import linkWrapper from '@/vue/components/linkWrapper/linkWrapper'

export default {
  name: "AlertBlock",
  components: {
    linkWrapper,
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    preamble: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss">
  .alert-block {
    background: $color-white;
    box-shadow: $box-shadow-primary;
    border-radius: 0.25rem;
    display: flex;
    margin-bottom: 1rem;

    &__message-type {
      min-width: 2rem;
      width: 2rem;
      background: $color-yellow-dark;
      border-radius: 0.25rem 0 0 0.25rem;
      align-self: stretch;

      &.information {
        background: $color-purple-dark;
      }
    }

    &__error-icon {
      fill: $color-white;
      margin: 0.5rem 0.25rem 0 0.25rem;
    }

    &__content {
      padding: 0.25rem 1rem 1.5rem 1.5rem;

      @include media-breakpoint-up(md) {
        padding: 0.25rem 4.5rem 1.5rem 2.5rem;
      }

      @include media-breakpoint-up(lg) {
        padding: 0.25rem 5rem 2rem 3rem;
      }

      @include media-breakpoint-up(xl) {
        padding: 0.75rem 19.5rem 2rem 3rem;
      }
    }

    &__title {
      margin-bottom: 0.5rem;

      @include font(rubrik, 1, medium);
    }

    &__text {
      margin-top: 0;
      margin-bottom: 1rem;

      @include font(text, 3, "light");
    }
  }
</style>
